<template>
  <v-app>
    <v-main>
      <!-- <MisemegMini /> -->
      <router-view/>
    </v-main>
  </v-app>
</template>
<script>
import { QrcodeReader } from 'vue-qrcode-reader'
export default {
  name: 'App',
  components: {
    QrcodeReader
  },
  data: () => ({
  }),
};
</script>
